<template>
  <app-collapse is-open>
    <template #heading>
      <app-icon
        :name="collapseData?.icon"
        :color="collapseData?.color"
        variant="solid"
        size="xs"
      />
      {{ collapseData?.heading }}
    </template>
    <div class="space-y-2 pl-2">
      <status-message
        v-for="error in statusMessages"
        :key="error"
        :message="error"
        direction="vertical"
        :color="statusMessageColor"
      >
        <template #message>
          <span class="font-normal">{{ error }}</span>
        </template>
      </status-message>
    </div>
  </app-collapse>
</template>

<script setup>
import { computed } from 'vue';
import { TransferStatus } from '@/constants/transfers';

const props = defineProps({
  transfer: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const collapseData = computed(() => {
  return {
    [TransferStatus.FAILED_VERIFICATION]: {
      heading: 'Action required',
      icon: 'alert-circle',
      color: 'warning',
    },
    [TransferStatus.CANCELED]: {
      heading: 'Errors',
      icon: 'close',
      color: 'error',
    },
  }[props.transfer.status];
});

const statusMessageColor = computed(() => {
  return {
    [TransferStatus.FAILED_VERIFICATION]: 'warning',
    [TransferStatus.CANCELED]: 'error',
  }[props.transfer.status];
});

const statusMessages = computed(() => {
  return [...new Set(props.transfer.errors.map((error) => error.message))];
});
</script>
